/// <reference path="../../libs.ts" />
import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IPerformExtractEncryptionActionOnFlowsRequestParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnFlowsRequest extends Request<IPerformExtractEncryptionActionOnFlowsRequestParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnFlows', {
      ids: ids,
      type: type
    });
  }
}
